module.exports = __webpack_public_path__ + "static/media/gpt_integrations.7eb07b25.png";